import Vue from 'vue'
import Router from 'vue-router'
import index from '../page/index'
import message from '../page/message'
import expertsrecommend from '../page/expertsrecommend'
import custom from '../page/custom'
import allProject from '../page/all_project'
import myProject from '../page/my_project'
import myReleasePjt from '../page/myRelease_pjt'
import myJoinPjt from '../page/myJoin_pjt'
import myRecommendPjt from '../page/myRecommend_pjt'
import myApplyPjt from '../page/myApply_pjt'
import projectDetail from '../page/projectDetail'
import login from '../page/login'
import regist from '../page/register'
import createPjt from '../page/create_pjt'
import updatePjt from '../page/updatePjt'
import resetPwd from '../page/resetPwd'
import resetNickname from '../page/resetNickname'

import myDetail from '../page/myDetail'
import projectApplyPopup from '../page/projectApplyPopup'
import withdraw from '../page/withdraw'
import tradeRecords from '../page/tradeRecords'
import pay from '../page/pay'
import recommendPeople from '../page/recommendPeople'
import applyPeople from '../page/applyPeople'
import myProjectDetail from '../page/myProjectDetail'
import closePjt from '../page/closePjt'
import applySuccess from '../page/applySuccess'
import createSuccess from '../page/createSuccess'
import evaluate from '../page/evaluate'
import evaluateList from '../page/evaluateList'
import hireExpert from '../page/hireExpert'
import evaluateSuccess from '../page/evaluateSuccess'
import hireExpertSuccess from '../page/hireExpertSuccess'
import binding from '../page/binding'
import accountBind from '../page/accountBind'
import moneySuccess from '../page/moneySuccess'
import waitmoney from '../page/waitmoney'

// 1.8改版我的页面
import me from '../page/my/index'
import certification from '../page/my/certification'
import baseinfo from '../page/my/baseinfo'
import skills from '../page/my/skills'
import personinfo from '../page/my/personinfo'
import addcase from '../page/my/addcase'
import editcase from '../page/my/editcase'

// 实名认证
import realName from '../page/realName/realName'
import realNameSuccess from '../page/realName/realNameSuccess'
import realNameFailed from '../page/realName/realNameFailed'

Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/project',
      component: allProject
    },
    {
      path: '/myJobs',
      component: myProject,
      children: [
        {path: '', component: myReleasePjt},
        {path: 'join', component: myJoinPjt},
        {path: 'recommend', component: myRecommendPjt},
        {path: 'apply', component: myApplyPjt}
      ]
    },
    {
      path: '/createProject',
      name: 'createPjt',
      component: createPjt
    },
    {
      path: '/updateProject',
      name: 'updatePjt',
      component: updatePjt
    },
    {
      path: '/message',
      name: 'message',
      component: message
    },
    {
      path: '/project/projectDetail',
      name: 'projectDetail',
      component: projectDetail
    },
    {
      path: '/passport/login',
      name: 'login',
      component: login
    },
    {
      path: '/passport/regist',
      name: 'regist',
      component: regist
    },
    {
      path: '/passport/resetPwd',
      name: 'resetPwd',
      component: resetPwd
    },
    {
      path: '/passport/resetNickname',
      name: 'resetNickname',
      component: resetNickname
    },
    {
      path: '/myDetail',
      name: 'myDetail',
      component: myDetail
    },
    {
      path: '/project/projectApplyPopup',
      name: 'projectApplyPopup',
      component: projectApplyPopup
    },
    {
      path: '/pay/withdraw',
      name: 'withdraw',
      component: withdraw
    },
    {
      path: '/pay/tradeRecords',
      name: 'tradeRecords',
      component: tradeRecords
    },
    {
      path: '/pay',
      name: 'pay',
      component: pay
    },
    {
      path: '/project/recommendPeople',
      name: 'recommendPeople',
      component: recommendPeople
    },
    {
      path: '/project/applyPeople',
      name: 'applyPeople',
      component: applyPeople
    },
    {
      path: '/project/myProjectDetail',
      name: 'myProjectDetail',
      component: myProjectDetail
    },
    {
      path: '/project/myProjectDetail/closePjt',
      name: 'closePjt',
      component: closePjt
    },
    {
      path: '/project/projectApplyPopup/applySuccess',
      name: 'applySuccess',
      component: applySuccess
    },
    {
      path: '/project/createProject/createSuccess',
      name: 'createSuccess',
      component: createSuccess
    },
    {
      path: '/project/evaluate',
      name: 'evaluate',
      component: evaluate
    },
    {
      path: '/project/evaluateList',
      name: 'evaluateList',
      component: evaluateList
    },
    {
      path: '/project/evaluate/evaluateSuccess',
      name: 'evaluateSuccess',
      component: evaluateSuccess
    },
    {
      path: '/project/hireExpert',
      name: 'hireExpert',
      component: hireExpert
    },
    {
      path: '/project/hireExpert/hireExpertSuccess',
      name: 'hireExpertSuccess',
      component: hireExpertSuccess
    },
    {
      path: '/my/binding',
      name: 'binding',
      component: binding
    },
    {
      path: '/my/binding/accountBind',
      name: 'accountBind',
      component: accountBind
    },
    {
      path: '/expertsrecommend',
      name: 'expertsrecommend',
      component: expertsrecommend
    },
    {
      path: '/custom',
      name: 'custom',
      component: custom
    },
    {
      path: '/moneySuccess',
      name: 'moneySuccess',
      component: moneySuccess
    },
    {
      path: '/waitmoney',
      name: 'waitmoney',
      component: waitmoney
    },
    // 1.8改版我的页面
    {
      path: '/me',
      name: 'me',
      component: me
    },
    {
      path:'/certification',
      name:'certification',
      component:certification
    },
    {
      path:'/baseinfo',
      name:'baseinfo',
      component:baseinfo
    },
    {
      path:'/skills',
      name:'skills',
      component:skills
    },
    {
      path:'/personinfo',
      name:'personinfo',
      component:personinfo
    },
    {
      path:'/addcase',
      name:'addcase',
      component:addcase
    },
    {
      path:'/editcase',
      name:'editcase',
      component:editcase
    },
    // 实名认证
    {
      path:'/realName',
      name:'realName',
      component:realName
    },
    {
      path:'/realNameSuccess',
      name:'realNameSuccess',
      component:realNameSuccess
    },
    {
      path:'/realNameFailed',
      name:'realNameFailed',
      component:realNameFailed
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js